import { render, staticRenderFns } from "./Handbook.vue?vue&type=template&id=552bba36&"
import script from "./Handbook.vue?vue&type=script&lang=js&"
export * from "./Handbook.vue?vue&type=script&lang=js&"
import style0 from "./Handbook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports